import { externalEvents } from "@closerplatform/closer-sdk";
import { WsEventListener } from "@fidget/common/services/eventsListener";
import { IAgentGroupStore } from "./agentGroupsStore";

export class AgentGroupsEventListener implements WsEventListener {
  constructor(private _agentGroupsFinder: () => IAgentGroupStore, public name: string) {}

  get agentGroupsStore(): IAgentGroupStore {
    return this._agentGroupsFinder();
  }

  agentGroupCreated(event: externalEvents.AgentGroupCreated) {
    this.agentGroupsStore.updateGroup({
      orgId: this.agentGroupsStore.currentUserStore.orgId ?? "",
      id: event.id,
      name: event.name,
      tags: [ ...event.tags ],
      tagGroups: [ ...event.tagGroups ],
      advisers: [ ...event.advisers ],
    });
  }

  agentGroupUpdated(event: externalEvents.AgentGroupUpdated) {
    this.agentGroupsStore.updateGroup({
      orgId: this.agentGroupsStore.currentUserStore.orgId ?? "",
      id: event.id,
      name: event.name,
      tags: [ ...event.tags ],
      tagGroups: [ ...event.tagGroups ],
      advisers: [ ...event.advisers ],
    });
  }

  agentGroupDeleted(event: externalEvents.AgentGroupDeleted) {
    this.agentGroupsStore.deleteGroup(event.id);
  }
}
